import Papa from 'papaparse';
export default file => new Promise((complete, error) => Papa.parse(file, { complete, error, skipEmptyLines: true }));



// WEBPACK FOOTER //
// ./app/src/papaparse.js